import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Flex } from '@chakra-ui/react'
import React, { useState } from 'react'

interface iProps {
  title: string
  left?: boolean
  hideHr?: boolean
  isOpen?: boolean
  grupo?: boolean
  icone?: React.ReactNode
}

export const AccordionContainer: React.FC<iProps> = ({ title, left, hideHr, children, isOpen, grupo, icone }) => {
  const [versao, setVersao] = useState(0)

  if (grupo) {
    return (
      <Accordion allowToggle w={'full'} index={isOpen ? 0 : undefined} onChange={(i) => { if (i === -1) setVersao(v => v + 1) }}>
        <AccordionItem border={'1px solid #D9DEE8'} borderRadius={'.75rem'} overflow={'hidden'} boxShadow={'0 2px 6px rgba(25, 97, 224, 0.08)'} mt={'.5rem'} bg={'var(--White)'}>
          {({ isExpanded }) => (
            <>
              <AccordionButton _focus={{ boxShadow: 'none !important' }} _hover={{ bg: '#EEF3FD' }} bg={isExpanded ? '#E8EEFC' : 'var(--White)'} borderLeft={'4px solid var(--Azul)'} px={'1rem'} py={'.75rem'} gap={'.9rem'}>
                {icone && <Flex w={'2.25rem'} h={'2.25rem'} borderRadius={'.5rem'} bg={'var(--White)'} boxShadow={'0 1px 3px rgba(0, 0, 0, 0.12)'} color={'var(--Azul)'} fontSize={'1.15rem'} alignItems={'center'} justifyContent={'center'} flexShrink={0}>{icone}</Flex>}
                <Flex as='span' flex={1} textAlign={'left'} fontSize={'1rem'} fontWeight={700} color={'#1B2430'}>{title}</Flex>
                <Flex w={'2rem'} h={'2rem'} borderRadius={'50%'} bg={isExpanded ? '#D5E0FA' : 'transparent'} color={'var(--Azul)'} alignItems={'center'} justifyContent={'center'}>
                  <AccordionIcon fontSize={'1.5rem'} />
                </Flex>
              </AccordionButton>
              <AccordionPanel py={'.5rem'} px={'1rem'}>
                <React.Fragment key={versao}>{children}</React.Fragment>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>
    )
  }

  return (
    <Accordion allowToggle w={'full'} index={isOpen ? 0 : undefined}>
      <AccordionItem>
        <AccordionButton _focus={{ boxShadow: 'none !important' }} bg={'var(--White)'} color={'var(--Azul)'} gap={'.3rem'} borderRadius={'1.25rem'} mt={'.5rem'} px={'0'}>
          {!left && <hr style={{ borderTop: '1px solid var(--Azul)', flex: '1', opacity: hideHr ? '0' : '' }}></hr>}
          <Flex as='span' textAlign={'left'} fontSize={'0.875rem'} gap={'.2rem'}>
            {title}
            <AccordionIcon />
          </Flex>
          {left && <hr style={{ borderTop: '1px solid var(--Azul)', flex: '1', opacity: hideHr ? '0' : '' }}></hr>}
        </AccordionButton>
        <AccordionPanel py={'0.25rem'} px={'0.25rem'}>
          {children}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
